export default "__VITE_ASSET__b81518cf__"